import React from "react";
import { config } from "../../config";

export default function Footer() {
  return (
    <footer>
      <p>Gosselin, Belcrownlaan 23, 2100 Antwerpen, Belgium</p>
      <p>You received this request because you appear in our supplier database.<br />By submitting your quote you accept our <a href={config.termsUrl} target="_blank" rel="noopener noreferrer">terms &amp; conditions</a> and <a href={config.slaUrl} target="_blank" rel="noopener noreferrer">SLA</a>.</p>
    </footer>
  );
}
